import { ExternalLink } from "lucide-react";

export const ProvenanceBlock = ({ p, t, testId }) => {
  if (!p) return null;
  const retrieved = (p.retrieved_at || "").slice(0, 19).replace("T", " ");
  return (
    <div className="mt-3 rounded-lg border border-slate-200 bg-slate-50 p-4 text-xs text-slate-600" data-testid={testId}>
      <p><span className="font-semibold">{t("report.source")}:</span> {p.authority}{p.dataset ? ` · ${p.dataset}` : ""}</p>
      {p.method && (
        <p className="mt-1"><span className="font-semibold">{t("flood.method")}:</span> {p.method}{p.query_basis ? ` · ${p.query_basis}` : ""}</p>
      )}
      {retrieved && (
        <p className="mt-1"><span className="font-semibold">{t("real.retrieved")}:</span> {retrieved}</p>
      )}
      {p.coverage && <p className="mt-1 text-slate-500">{p.coverage}</p>}
      {p.error && (
        <p className="mt-1 text-amber-700" data-testid={testId ? `${testId}-error` : undefined}>
          <span className="font-semibold">{t("report.sourceError")}:</span> {p.error}
        </p>
      )}
      {p.service_url && (
        <p className="mt-2">
          <a href={p.service_url} target="_blank" rel="noreferrer"
             data-testid={testId ? `${testId}-open-source` : undefined}
             className="inline-flex items-center gap-1 rounded-md border border-slate-300 bg-white px-2.5 py-1 font-semibold text-emerald-700 hover:bg-emerald-50">
            <ExternalLink size={12} /> {t("report.openSource")}
          </a>
        </p>
      )}
    </div>
  );
};
